<script>
	export default {
		name: 'InputExecuter',
		methods: {
			storeInput() {
				const self_ = this;

				const datetime_ = self_.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
				const uid_ = self_.getCurrentUser('uid')

				const pageName_ = self_.getInputState('pageName')
				const pageType_ = self_.getInputState('pageType')
				const data_ = self_.getInputState('data')

				return self_.ipCliStoreAppInputs(datetime_, uid_, pageName_, pageType_, data_)
			},
			addInputSales(inputKey, inputType) {
				const self_ = this;

				const set_ = (docId, subCollectionName, subDocId, value) => {
					self_.setFirestoreSubDocument('inputs', docId, subCollectionName, subDocId, value)
				}
				
				const data_ = self_.getInputState(inputType)

				let promiseArray_ = []

				Object.keys(data_).forEach(id => {
					promiseArray_.push(set_(inputKey, inputType, id, data_[id]))
				})
				
				return Promise.all(promiseArray_)
			}
		}
	}
</script>